import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import EraType from '@/roc/era/EraType';

const Yggdrasil = {
  id: '70',
  name: 'Yggdrasil',
  era: EraType.earlyRome,
  icon: 'ygg',
  gameId: 'Yggdrasil',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.STORIES_AND_MYTHS,
  kind: WonderKind.STATUE | WonderKind.NATURE,
  kindMultiplier: 2,
  owner: WonderOwner.VIKINGS,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.VIKINGS_TAVERN_PRODUCTION_MOD,
      EffectAmount.asPerLevel([
        10,
        13,
        15,
        16.5,
        18,   // 5
        19.5,
        20.5,
        22.0,
        23.0,
        24.0, // 10
        24.5,
        25.5,
        26.5,
        27,
        28,   // 15
        28.5,
        29,
        30,
        30.5,
        31, // 20
        31.5,
        32.5,
        33,
        33.5,
        34,   // 25
        34.5,
        35,
        35.5,
        36,
        36.5  // 30
      ]),
      '%',
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asFlat(1)
        .withOutput(ProductionOutputType.CHEST)
        .withDescription('Produce chest which can include building customizations from previous events.')
      ,
    ),
  ]),
  synergies: [],
};

export default Yggdrasil;
